import { useQuery } from '@tanstack/react-query';

import { api, getQueryProps, isTruthy } from 'common';

import { type BlockRunDataVariant } from './Runs/Run/contexts/pageContext';

interface FindLatestTestRunApiProps {
  flowDefinitionId: string | null;
  blockRunDataVariant?: BlockRunDataVariant;
  staleTime?: number;
}

export function useFindLatestTestRunApi(props: FindLatestTestRunApiProps) {
  const { flowDefinitionId, blockRunDataVariant, staleTime } = props;
  const result = useQuery({
    ...getQueryProps(
      api.client.FlowDefinition,
      'findLatestTestRun',
      flowDefinitionId ?? 'INVALID_ID',
      blockRunDataVariant
    ),
    select: (data) => data.latestRun,
    enabled: isTruthy(flowDefinitionId),
    staleTime,
  });

  return result;
}
